/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-resource-form.vue?vue&type=template&id=45b1becc&scoped=true&"
import script from "./add-resource-form.vue?vue&type=script&lang=js&"
export * from "./add-resource-form.vue?vue&type=script&lang=js&"
import style0 from "./add-resource-form.vue?vue&type=style&index=0&id=45b1becc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1becc",
  null
  
)

export default component.exports